module.exports = __webpack_public_path__ + "images/vehicle_alarm.6eb5f19b33ae09df48b6bea5ee4867b5.svg";